// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"d715a3e390ae8e0c","5405":"7109a3c903522345","8270":"e37398707d0528fe"}[chunkId] + ".css";
};